module.exports = __webpack_public_path__ + "images/android-chrome-192x192.1fcd2a23d388835f416a5e1b5cdbbe4f.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/android-chrome-192x192.png
// module id = 986
// module chunks = 0